export default {
  carouselTextContainer: {
    top: ['27%', '35%'],
  },
}
